import { defineComponent as t, openBlock as r, createBlock as o, unref as c, mergeProps as m, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceParcelOutlined",
  __name: "IconReassuranceParcelOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (u, e) => (r(), o(c(s), m(n, { "view-box": "0 0 48 48" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", { d: "M29.403 28.079c.342.063.726-.459.856-1.161.13-.703-.04-1.327-.383-1.39-.342-.064-.725.458-.856 1.16-.13.703.041 1.328.383 1.39m2.993-2.628c-.027.711.227 1.303.578 1.32.387.025.658-.556.684-1.269s-.227-1.304-.577-1.321-.658.557-.685 1.27m-6.55 2.312a.3.3 0 0 0-.093.042l.037.007a.263.263 0 0 0-.181.31 5.64 5.64 0 0 0 1.889 2.655 8 8 0 0 0 .908.618 6.8 6.8 0 0 0 2.063.736 6.5 6.5 0 0 0 2.158.018.264.264 0 0 0-.038-.514 7.6 7.6 0 0 1-3.734-1.008 7.2 7.2 0 0 1-1.502-1.235 10.6 10.6 0 0 1-1.239-1.52.25.25 0 0 0-.268-.109" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M9.836 10.954A2.5 2.5 0 0 1 12.75 8.95l26.075 4.833a2.5 2.5 0 0 1 2.003 2.914l-3.662 19.758a2.5 2.5 0 0 1-2.914 2.002l-26.075-4.83a2.5 2.5 0 0 1-2.003-2.914l3.662-19.758m2.731-1.02 8.598 1.594-1.665 8.985a.5.5 0 0 0 .81.476l4.366-3.623 2.777 4.946a.5.5 0 0 0 .927-.153l1.665-8.985 8.598 1.593a1.5 1.5 0 0 1 1.202 1.749l-3.662 19.758a1.5 1.5 0 0 1-1.749 1.201L8.36 32.642a1.5 1.5 0 0 1-1.202-1.748l3.662-19.758a1.5 1.5 0 0 1 1.748-1.201m9.581 1.776 6.914 1.282-1.414 7.627-2.687-4.79-4.226 3.508 1.413-7.627",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
